import request from '@/utils/request'

// 站内信消息列表
export function getNoticeList(params) {
    return request({
        url: '/stationMsg/getMessageList',
        method: 'get',
        params: params,
        noRemoveEmptyProps: true,
    })
}

// 站内信消息列表
export function noreadNotice(params) {
    return request({
        url: '/stationMsg/getUnreadMsgCount',
        method: 'get',
        params: params
    })
}

// 删除站内信
export function deleteNotice(params) {
    return request({
        url: '/stationMsg/delete',
        method: 'delete',
        params: params
    })
}

// 读站内信
export function readNotice(id) {
    return request({
        url: `/stationMsg/messageOperate?messageId=${id}`,
        method: 'post'
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js